import AuthApi from '../api/AuthApi';
import AuthConstants from '../constants/AuthConstants';
import Immutable from 'immutable';

/**
 * @desc post message with current login status
 * @param {boolean} status defines if user is logged in or not
 */
function _postLoginStatus(status) {
  if (typeof window.parentIFrame !== 'undefined') {
    const postMessagePayload = {
      userLoggedIn: status,
      name: window.name
    };

    window.parentIFrame.sendMessage(postMessagePayload, '*');
  }
}

function loadUser() {
  return {
    types: [
      AuthConstants.AUTH_LOAD_USER_REQUEST,
      AuthConstants.AUTH_LOAD_USER_SUCCESS,
      AuthConstants.AUTH_LOAD_USER_FAILURE
    ],
    apiRequest: (state, client) => AuthApi.loadUser(client)
  };
}

function login(username, pin) {
  return {
    types: [
      AuthConstants.AUTH_LOGIN_REQUEST,
      AuthConstants.AUTH_LOGIN_SUCCESS,
      AuthConstants.AUTH_LOGIN_ERROR
    ],
    apiRequest: (state, client) => AuthApi.login(username, pin, client),
    postSuccess: state => {
      const postLoginAction = state.getIn(['auth', 'postLoginAction']);
      _postLoginStatus(true);

      if (Immutable.Iterable.isIterable(postLoginAction)) {
        return postLoginAction.toJS();
      }
      return postLoginAction;
    }
  };
}

function logout() {
  _postLoginStatus(false);

  return {
    type: AuthConstants.AUTH_LOGOUT
  };
}

function closeLoginOverlay() {
  return {
    type: AuthConstants.CLOSE_LOGIN_OVERLAY
  };
}

export default {
  login,
  logout,
  loadUser,
  closeLoginOverlay
};



// WEBPACK FOOTER //
// ./app/actions/AuthActions.js